import store from '@/store/store';
import mutationType from '@/store/mutation-types';
import breadCrumb from '@/store/breadCrumb';
import Vue from 'vue';
import Router from 'vue-router';
import gtSuccess from '@/components/service/success/gt-success.vue';
import gtWarn from '@/components/service/warn/gt-warn.vue';
import gtError from '@/components/service/error/gt-error.vue';
import {authUtil} from '@/util/plugins'

//-------
import home from '@/components/home.vue';
//-------
import authorizeApi from '@/api/authorize/authorizeApi';
import bidApi from '@/api/bid/bidApi';

import Profile from '@/model/common/profile';

//basicSetting共用頁面
import commonView from '@/components/basicSetting/commonView/commonView.vue';
import commonViewResult from '@/components/basicSetting/commonView/commonViewResult.vue'
//開啟VoLTE
import lteFlagSwitch from '@/components/basicSetting/lteFlagSwitch/lteFlagSwitch.vue';
//快速復話
import quickRestart from '@/components/basicSetting/quickRestart/quickRestart.vue'
import quickRestartResult from '@/components/basicSetting/quickRestart/quickRestartResult.vue'
// 加值服務
// 566情境答鈴
import situationRing from '@/components/addSetting/situationRing.vue';
// 560來電答鈴
import receiveRing from '@/components/addSetting/receiveRing.vue';
// 時間管理小褓姆
import netScheduling from '@/components/addSetting/netScheduling/netScheduling.vue';

// 快樂包
import happyPackage from '@/components/happyPackage/happyPackage.vue';
import happyPackageGroup from '@/components/happyPackageGroup/happyPackageGroup.vue';

//掛失/停話/復話
import useChange from '@/components/basicSetting/useChange/useChange.vue'
import useChangeResult from '@/components/basicSetting/useChange/useChangeResult.vue'
import useChangeWarning from '@/components/basicSetting/useChange/useChangeWarning.vue'
//靜態頁面
import selectVoicEmail from '@/components/basicSetting/staticView/selectVoicEmail.vue'
import multiPartyCall from '@/components/basicSetting/staticView/multiPartyCall.vue'
import dataUsageRemind from '@/components/basicSetting/staticView/dataUsageRemind.vue'
import transferCall from '@/components/basicSetting/staticView/transferCall.vue'

import redirect from '@/components/redirect/redirect.vue';
// 漫遊
import dataRoaming from '@/components/dataRoaming/dataRoaming.vue'
import voiceRoaming from '@/components/dataRoaming/voiceRoaming.vue'
import voiceRoamingResult from '@/components/dataRoaming/voiceRoamingResult.vue'
// 首頁
import functionList from '@/components/functionList/functionList.vue'

// bid 立即申辦
import bidHome from '@/components/bid/bidHome.vue'
import bidLogin from '@/components/bid/bidLogin.vue'
import bidWarn from '@/components/bid/warn/bidWarn.vue'
import bidSuccess from '@/components/bid/success/bidSuccess.vue'
import bidError from '@/components/bid/error/bidError.vue'

Vue.use(Router);

const router = new Router({
    // scrollBehavior (to, from, savedPosition) {
    // 	return { x: 0, y: 0 }
    // },
    // mode: 'history',
    routes: [

        {
            path: '',
            name: 'service-home',
			redirect: '/functionList',
            component: home,
            children: [{
                    path: 'success',
                    name: 'gt-success',
                    props: true,
                    component: gtSuccess,
                },
                {
                    path: 'warn',
                    name: 'gt-warn',
                    props: true,
                    component: gtWarn,
                },
                {
                    path: 'error',
                    name: 'gt-error',
                    props: true,
                    component: gtError,
                },
                {
                    path: 'redirect',
                    name: 'redirect',
                    props: true,
                    component: redirect,
                },
                {
                    path: 'BasicSetting/lteFlagSwitch',
                    name: 'lte-flag-switch',
                    props: true,
                    component: lteFlagSwitch,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                // 國際漫遊服務設定
                {
                    path: 'RoamingSetting/dataRoaming',
                    name: 'data-roaming',
                    props: true,
                    component: dataRoaming,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.ROAMING]
                    }
                },
                {
                    path: 'RoamingSetting/voiceRoaming',
                    name: 'voice-roaming',
                    props: true,
                    component: voiceRoaming,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.ROAMING]
                    }
                }, ,
                {
                    path: 'RoamingSetting/voiceRoamingResult',
                    name: 'voice-roaming-result',
                    props: true,
                    component: voiceRoamingResult,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.ROAMING]
                    }
                },
                {
                    path: 'BasicSetting/quickRestart',
                    name: 'quick-restart',
                    props: true,
                    component: quickRestart,
                    meta: {
                        breadCrumb: [breadCrumb.SETTING, breadCrumb.QUICK_RESTART]
                    }
                },
                {
                    path: 'BasicSetting/quickRestart/result',
                    name: 'quick-restart-result',
                    props: true,
                    component: quickRestartResult,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                // 加值服務
                // 566情境答鈴

                // email: eCare新風格頁面-內頁麵包削要改
                // 566情境答鈴這個服務可以下架~ by Cindy
                /*
                {
                    path: 'AddSetting/situationRing',
                    name: 'situation-ring',
                    props: true,
                    component: situationRing,
                    meta: {
                        breadCrumb: '566情境答鈴'
                    }
                },
                */
                // 560來電答鈴
                {
                    path: 'AddSetting/receiveRing',
                    name: 'receive-ring',
                    props: true,
                    component: receiveRing,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.RING]
                    }
                },
                // 加值服務-快樂包
                {
                    path: 'HappyPackageGroup/:selectedKey',
                    name: 'happy-package-group',
                    props: true,
                    component: happyPackageGroup,
                    meta: {
                        //breadCrumb: '加值服務-快樂包'
                    }
                },
                {
                    path: 'HappyPackage/:selectedKey',
                    name: 'happy-package',
                    props: true,
                    component: happyPackage,
                    meta: {
                        //breadCrumb: '加值服務-快樂包'
                    }
                },
                {
                    path: 'BasicSetting/useChange',
                    name: 'use-change',
                    props: true,
                    component: useChange,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                {
                    path: 'BasicSetting/useChange/result',
                    name: 'use-change-result',
                    props: true,
                    component: useChangeResult,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                {
                    path: 'BasicSetting/useChange/warning',
                    name: 'use-change-warning',
                    props: true,
                    component: useChangeWarning,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                {
                    path: 'BasicSetting/selectVoicEmail',
                    name: 'select-voice-email',
                    props: true,
                    component: selectVoicEmail,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                {
                    path: 'BasicSetting/multiPartyCall',
                    name: 'static-view',
                    props: true,
                    component: multiPartyCall,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                {
                    path: 'BasicSetting/dataUsageRemind',
                    name: 'data-usage-remind',
                    props: true,
                    component: dataUsageRemind,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                {
                    path: 'BasicSetting/transferCall',
                    name: 'transfer-call',
                    props: true,
                    component: transferCall,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                {
                    path: 'BasicSetting/:service',
                    name: 'common-view',
                    props: true,
                    component: commonView,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                {
                    path: 'BasicSetting/:service/result',
                    name: 'common-view-result',
                    props: true,
                    component: commonViewResult,
                    meta: {
                        breadCrumb: [breadCrumb.SERVICE, breadCrumb.BASIC_SETTING]
                    }
                },
                // 首頁
                {
                    path: 'functionList',
                    name: 'function-list',
                    props: true,
                    component: functionList,
                }

            ]
        },
        
        {
			path: '/bid',
			name: 'bid-home',
			component: bidHome,
			children: [
				{
					path: 'login',
					name: 'bid-login',
					props: true,
					component: bidLogin
				},
                {
                    path: 'bidSuccess',
					name: 'bid-success',
					props: true,
					component: bidSuccess
                },
                {
                    path: 'bidWarn',
					name: 'bid-warn',
					props: true,
					component: bidWarn
                },
                {
                    path: 'bidError',
					name: 'bid-error',
					props: true,
					component: bidError
                }
			]
			
		},

        // { path: '/', redirect: '' },

        {
            path: '*',
            name: 'gt-error-404',
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    }
});

const regBid = /\/bid\/*/;
const regxHp = /\/happypackage\/*/;
router.beforeEach(async(to, from, next) => {

    let preHistoryPage = sessionStorage.getItem('historyPage');
    if (!to.path.startsWith('/redirect') && !to.path.startsWith('/error')) {
		sessionStorage.setItem('historyPage', `${window.location.pathname}#${to.fullPath}`);
    }

    if (to.name === 'gt-error-404') {
        location.replace(process.env.PAGE_404);
    }

    // 加入麵包屑的值
	store.commit(mutationType.breadCrumb, to.meta.breadCrumb);

    // 加入此處的功能不需要登入即可進入
    let notLoginNames = ['redirect', 'function-list', 'happy-package-group', 'service-home', 'gt-sidebar', 'gt-success', 'gt-warn', 'gt-error', 'bid-home', 'bid-login', 'bid-success', 'bid-warn', 'bid-error'];

    // 判斷使用者資訊
    try {
        const profile = new Profile();
        await authorizeApi.auth();

        if (notLoginNames.indexOf(to.name) > -1) {
            if (to.name == 'bid-login') {
                sessionStorage.setItem('historyPage', preHistoryPage);
            }
			// 若即將前往的頁面包含於不需登入功能之中
			if (!store.state.profile.name && sessionStorage.getItem('cas')) {
				const result = await authorizeApi.getUserProfile();
				if(result){
					saveUserProfile(result);
				} else {
					return;
				}
			} else if (!store.state.profile.name || !sessionStorage.getItem('cas')) {
				const result = await authorizeApi.getUserProfileNotRedirect();
				if(result && result.code != 401){
					saveUserProfile(result);
				}
			}
        } else if (regBid.test(to.path.toLowerCase())) {
            let pass = false;
			if (sessionStorage.getItem('bidMdn') && sessionStorage.getItem('bidToken')) {
				pass = await bidApi.verifyToken(sessionStorage.getItem('bidMdn'), sessionStorage.getItem('bidToken') );
			}
			// 驗證不通過 導向首頁
			if(!pass){
				// 移除sessionStorage
				sessionStorage.removeItem("bidMdn");
				sessionStorage.removeItem("bidToken");
				next({ name: 'bid-login' });
				return;
			}
        } else if (regxHp.test(to.path.toLowerCase())) {
            let pass = false;
            if (!store.state.profile.name && !sessionStorage.getItem('cas')) {
                // 檢查是否有一般登入
                const result = await authorizeApi.getUserProfileNotRedirect();
                if(result && result.code != 401){
                    // 有一般登入
                    saveUserProfile(result);
                } else {
                    // 若沒有一般登入，檢查是否有快速登入權限
                    const selectedKey = to.params.selectedKey;
                    const bidLoginName = 'bid-login';
                    const bidType = 'happyPackageGroup';
                    const returnUrl = `%2FService%2F%23%2FHappyPackage%2F${selectedKey}`;

                    // 檢查sessionStorage是否存有快速登入資訊
                    if (sessionStorage.getItem('bidMdn') && sessionStorage.getItem('bidToken') && sessionStorage.getItem('bidReturnLoginUrl')) {
                        // sessionStorage存有快速登入資訊，檢查是否合法
                        pass = await bidApi.verifyToken(sessionStorage.getItem('bidMdn'), sessionStorage.getItem('bidToken') );
                        if(!pass){
                            // 不合法，移除快速登入資訊，導向快速登入
                            sessionStorage.removeItem("bidMdn");
                            sessionStorage.removeItem("bidToken");
                            sessionStorage.removeItem("bidReturnLoginUrl");

                            // 不導向快樂包，以前一個historyPage覆蓋掉快樂包的紀錄
                            sessionStorage.setItem('historyPage', preHistoryPage);
                            next({ name: bidLoginName, query: { bidType: bidType, returnUrl: returnUrl } });
                            return;
                        } else {
                            // 合法，驗證目的地與原快速登入的快樂包是否相同
                            if(!sessionStorage.getItem('bidReturnLoginUrl').endsWith(selectedKey)) {
                                // 不導向快樂包，以前一個historyPage覆蓋掉快樂包的紀錄
                                sessionStorage.setItem('historyPage', preHistoryPage);
                                next({ name: bidLoginName, query: { bidType: bidType, returnUrl: returnUrl } });
                                return;
                            }
                        }
                    } else {
                        // 2021-02-23 tony 根據需求，若都沒有登入, 則直接導到 SSO 登入頁，而不是 bid-login 登入頁
                        await authorizeApi.getUserProfile();
                        // // sessionStorage沒有快速登入資訊，導向快速登入
                        // // 不導向快樂包，以前一個historyPage覆蓋掉快樂包的紀錄
                        // sessionStorage.setItem('historyPage', preHistoryPage);
                        // next({ name: bidLoginName, query: { bidType: bidType, returnUrl: returnUrl } });
                        return;
                    }
                }
            } else if (!store.state.profile.name || !sessionStorage.getItem('cas')) {
				const result = await authorizeApi.getUserProfile();
				if(result){
					saveUserProfile(result);
				} else {
					return;
				}
            }
        }  else {
			if (!store.state.profile.name || !sessionStorage.getItem('cas')) {
				const result = await authorizeApi.getUserProfile();
				if(result){
					saveUserProfile(result);
				} else {
					return;
				}
			}
        }
    } catch (error) {
        console.log('error=', error)
        location.replace(process.env.MAIN_PAGE);
        return;
    }
    if(!store.state.profile.visit){
      store.commit(mutationType.profile, {visit: true});
    }
    next();
});

function saveUserProfile(userProfile) {
	const profile = new Profile();
	profile.buildFromObject(userProfile);
	store.commit(mutationType.profile, profile);
	// 給 auth() 使用
	authUtil.setSessionStorage({
		loginType: 'cas',
		option: {
			productType: userProfile.productType,
			contractStatus: userProfile.contractStatus,
			identity: authUtil.getIdentity(userProfile.pid)
		}
	})
}

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js